/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Beta_TitleInputs */

const da_admin_beta_title = /** @type {(inputs: Admin_Beta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betaanmodninger`)
};

/** @type {(inputs: Admin_Beta_TitleInputs) => LocalizedString} */
const en_admin_beta_title = da_admin_beta_title;

/**

* @param {Admin_Beta_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const admin_beta_title = /** @type {((inputs?: Admin_Beta_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Beta_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_beta_title(inputs)
	return /** @type {LocalizedString} */ ("Betaanmodninger")
});